import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './SourceDotsPopup.css';
import SourceLang from './SourceLang.json';
import { AiOutlineTag, AiOutlineDelete } from "react-icons/ai";

import { useNavigate } from "react-router-dom";

class SourceDotsPopup extends React.Component {

	onPopUpClosed() {
		this.props.setSourceDotsPopupYN(false);
	}
	
	async onClickViewMarkdown() {
		var sourceIndex = this.props.sourceIndex;
		this.props.setSourceIndex(sourceIndex);
		var navigate = this.props.navigate;
  		navigate("/source/markdown");
		this.onPopUpClosed();
	}
	
	async onClickViewChunks() {
		var sourceIndex = this.props.sourceIndex;
		this.props.setSourceIndex(sourceIndex);
		var navigate = this.props.navigate;
  		navigate("/source/chunks");
		this.onPopUpClosed();
	}
	
	async onClickDelete() {
		this.props.setSourceDeletePopupYN(true);
		this.onPopUpClosed();
	}
	
	getExtFromFilename(filename) {
		var ext = filename.substr(filename.lastIndexOf('.') + 1);
		return ext.toLowerCase();
	}

	renderContent() {
		
		var ownerYN = this.props.ownerYN;
		var showRemoveSourceYN = false;
		if (ownerYN) {
			showRemoveSourceYN = true;
		}
		
		var sourceIndex = this.props.sourceIndex;
		var sourceArray = this.props.sourceArray;
		var itemObj = sourceArray[sourceIndex];
		var filenameExt = itemObj.filename;
		var ext = this.getExtFromFilename(filenameExt);

		var showViewSourceMarkdownYN = false;
		if (ext !== "txt") {
			showViewSourceMarkdownYN = true;
		}

		return (
			<div className="SourceDotsPopupTopContainer">
				<div style={{height: "10px"}}></div>
				{showViewSourceMarkdownYN && (<div
				  role="menuitem"
				  className="SourceDotsPopupLink"
				  onClick={() => this.onClickViewMarkdown()}
				>
					<div className="SourceDotsPopupLinkColumn1">
						<AiOutlineTag style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					<div className="SourceDotsPopupLinkColumn2">{this.props.getLang(SourceLang, "viewSourceMarkdown")}</div>				  					  
				</div>)}
				<div
				  role="menuitem"
				  className="SourceDotsPopupLink"
				  onClick={() => this.onClickViewChunks()}
				>
					<div className="SourceDotsPopupLinkColumn1">
						<AiOutlineTag style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					<div className="SourceDotsPopupLinkColumn2">{this.props.getLang(SourceLang, "viewSourceChunks")}</div>				  					  
				</div>
				{showRemoveSourceYN && (<div
				  role="menuitem"
				  className="SourceDotsPopupLink"
				  onClick={() => this.onClickDelete()}
				>
					<div className="SourceDotsPopupLinkColumn1">
						<AiOutlineDelete style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					<div className="SourceDotsPopupLinkColumn2">{this.props.getLang(SourceLang, "removeSource")}</div>				  					  
				</div>)}
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		var positionX = this.props.positionX;
		var positionY = this.props.positionY;

		return (
			<Popup
				className="source-dots-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				contentStyle={{
					position: 'fixed',
					top: positionY,
					left: positionX,
				}}
				overlayStyle={{ background: 'rgba(0, 0, 0, 0)' }}
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default function SourceDotsPopupFunction(props) {
	const navigate = useNavigate();
	return <SourceDotsPopup {...props} navigate={navigate} />;
}



